<template>
  <div ref="editor"></div>
</template>
<script>
export default {
  name: 'EasyEditor',
  props: {
    // 占位文字
    placeholder: {
      type: String,
      default: '',
    },
    // 最小高度
    minHeight: {
      type: String,
      default: '400px',
    },
    // 是否使用草稿
    localSave: {
      type: Boolean,
      default: false,
    },
    // 一次最多上传多少张图片
    uploadImgMaxLength: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      // 编辑器对象
      editor: null,
    };
  },
  mounted() {
    this.initEditor();
  },
  methods: {
    // 初始化编辑器
    initEditor() {
      const editor = new window.wangEditor(this.$refs.editor);
      editor.customConfig = {
        menus:['undo','redo','formatStyle','fontFamily','fontSize','bold','italic','underline','foreColor','backgroundColor','textAlign','UnorderedList','OrderedList','link','more','facial','img','video'],
        uploadImgServer: '/media/v1/upload',
        uploadImgLocal: '/media/v1/localize',
        uploadImgMaxLength: this.uploadImgMaxLength,
        placeholder: this.placeholder,
        localSave: this.localSave,
        onlytxt: false,
        autoLoadDraft: false,
        draftKey: '',
        uploadImgMaxSize: 20 * 1024 * 1024,
        uploadImgTimeout: 300000,
        imgHostWhiteList: ['media.canada-cn.net'],
        change: () => {
          const html = editor.txt.html();
          const text = editor.txt.text();
          // 非表情图片
          const images = [].slice
            .call(document.querySelectorAll('.edite-ement img:not(.facial-expression)'))
            .map(i => i.src);
          // 全部图片
          const allImage = [].slice.call(document.querySelectorAll('.edite-ement img')).map(i => i.src);
          // 视频
          const videos = [].slice.call(document.querySelectorAll('iframe[src*="youtube.com"]')).map(v => v.src);

          // 编辑器是否有内容
          const isEmpty = text.length == 0 && allImage.length == 0 && videos.length == 0;

          this.$emit('change', { html, text, images, videos, editor, isEmpty });
        },
      };
      editor.create();

      const editorContent = editor.$editeContainer[0];
      editorContent.style.minHeight = this.minHeight;
      editorContent.blur();

      this.editor = editor;
    },
    // 设置内容
    html(htmlContent) {
      if (htmlContent == null) {
        return this.editor.txt.html();
      } else {
        this.editor.txt.html(htmlContent);
        this.editor.$editeContainer[0].blur();
      }
    },
    // 获取文本
    text(textContent) {
      if (textContent == null) {
        return this.editor.txt.text();
      } else {
        this.editor.txt.text(textContent);
        this.editor.$editeContainer[0].blur();
      }
    },
    // 清空内容
    clear() {
      this.html('');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .editor-toolbar .tool-fix .toolbar-item-column{line-height: 20px;}
  .editor-txt-content {
    height: auto;
  }
}
</style>
